import React, { useState, useEffect, useRef, useContext } from 'react'
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../Base/Components/Card/Card'
import { toastShow } from '../../../Base/Services/ToastService';
import { getUsersBasic } from '../../../Base/API/Users/UserRequests';

import {  getRoles } from '../../../API/IT/Roles/RolesRequests';
import { sendNotification } from '../../../API/Notificaciones/NotificacinesRequests';
import { decodeToken } from 'react-jwt';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

function NewsScreen() {

    const { userAuth } = useContext(AuthContext);

    const toast = useRef(null);

    const [titulo, setTitulo] = useState('');
    const [contenido, setContenido] = useState('');
    const [areaSelected, setAreaSelected] = useState([]);
    const [areas, setAreas] = useState([]);
    const [tipo, setTipo] = useState(0);
    const [Url, setUrl] = useState('');
    const [version, setVersion] = useState('');
    const [enviarA, setEnviarA] = useState(2);
    const [userSelected, setUserSelected] = useState([]);
    const [users, setUsers] = useState([]);
    const [showErrors, setShowErrors] = useState(false);

    const getInfo = async () => {
        const areas = await getRoles();
        const users = await getUsersBasic();
        setAreas(areas);
        setUsers(users);
        // setAreasOptions(areas.map(area => ({ label: area.Area, value: area })));
    }

    const verificarCampos = () => {
        if (tipo === 0) {
            if (titulo === '' ||  enviarA === null) {
                return false;
            }
        }
        if (tipo === 1) {
            if (areaSelected === null || version === '') {
                return false;
            }
        }
        if (tipo === 2) {
            if (titulo === '' ||  enviarA === null || Url === '') {
                return false;
            }
        }

        if (enviarA === 1) {
            if (areaSelected.length === 0) {
                return false;
            }
        }
        if (enviarA === 2) {
            if (userSelected.length === 0) {
                return false;
            }
        }
        return true;
    }


    const enviarNoticia = async () => {

        setShowErrors(false);
        if (verificarCampos()) {

            let usersSend = '';
            let title = titulo;
            let body = contenido;
            let data = {};

            if (enviarA === 0) {
                usersSend = users.map(user => user.idUser);
            }
            if (enviarA === 1) {
               
                usersSend = areaSelected.map(Rol => users.filter(user => user.IdRol === Rol.IdRol).map(user => user.idUser)).flat();
            }
            if (enviarA === 2) {
                usersSend = userSelected.map(user => user.idUser);
            }

            if(tipo === 1){
                title = 'Nueva actualización disponible';
                body =  `Se ha publicado la versión ${version}`;
                data = {actualizacion: "true"}
            }
            if(tipo === 2){
                data = {Url: Url}
            }


            const notificacion = {
                title,
                body,
                data,
                usuarios: usersSend,
                Tipo: 2,
                UserSend: userAuth.idUser
            }
            console.log({enviarA});
            console.log(notificacion);
            const t = await sendNotification(notificacion);
            if(t?.valid){
                toastShow(toast, 'success', 'Noticia enviada');
                // setTitulo('');
                // setContenido('');
                // setAreaSelected([]);
                // setTipo(0);
                // setUrl('');
                // setVersion('');
                // setEnviarA(2);
                // setUserSelected([]);
                
            }else{
                toastShow(toast, 'error', 'Error al enviar noticia');
            }
        } else {
            toastShow(toast, 'error', 'Faltan campos por llenar');
            setShowErrors(true);
        }
    }
    useEffect(() => {
        window.document.title = 'PPF • News';
        getInfo();
    }, [])


    return (
        <div className='p-5 '>
            <Toast position="bottom-right" ref={toast} />
            <Card
                titulo={<h3>News</h3>}

                contenido={<div className='p-4'>



                    <Card titulo={<h5>Tipo</h5>}
                        contenido={<div className='p-4 d-flex'>
                            <div className="field-radiobutton" onClick={(e) => setTipo(0)}>
                                <RadioButton name="Tipo" value={0} checked={tipo === 0} />
                                <label className='mx-2' htmlFor="city4">Mensaje</label>
                            </div>
                            <div className="field-radiobutton" onClick={(e) => setTipo(1)}>
                                <RadioButton name="Tipo" value={1} checked={tipo === 1} />
                                <label className='mx-2' htmlFor="city4">Actualización</label>
                            </div>
                            <div className="field-radiobutton" onClick={(e) => setTipo(2)}>
                                <RadioButton name="Tipo" value={2} checked={tipo === 2} />
                                <label className='mx-2' htmlFor="city4">Link</label>
                            </div>
                        </div>}
                    />

                    <Card
                        titulo={<h5>Contenido</h5>}
                        contenido={<div>
                            {tipo !== 1 ? (<div>
                                {/* TITULO */}
                                <div className="p-float-label my-4">
                                    <InputText
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                        className={classNames({ 'p-invalid': titulo === '' && showErrors })}
                                        // disabled={!editable}
                                        style={{ minWidth: '400px' }}
                                    />
                                    <label>Titulo</label>
                                </div>

                                {/* CONTENIDO */}
                                <div className="p-float-label my-4">
                                    <InputText
                                        value={contenido}
                                        onChange={(e) => setContenido(e.target.value)}
                                        className={classNames({ 'p-invalid': contenido === '' && showErrors })}
                                        // disabled={!editable}
                                        style={{ minWidth: '800px' }}
                                    />
                                    <label>Contenido</label>
                                </div>


                                {/* URL */}
                                {tipo === 2 && <div className="p-float-label my-4">
                                    <InputText
                                        value={Url}
                                        onChange={(e) => setUrl(e.target.value)}
                                        className={classNames({ 'p-invalid': Url === '' && showErrors })}
                                        // disabled={!editable}
                                        style={{ minWidth: '400px', width: '100%' }}
                                    />
                                    <label>Url</label>
                                </div>}


                            </div>) :


                                <div>

                                    {/* VERSION */}
                                    <div className="p-float-label my-4">
                                        <InputText
                                            value={version}
                                            onChange={(e) => setVersion(e.target.value)}
                                            className={classNames({ 'p-invalid': version === '' && showErrors })}
                                            // disabled={!editable}
                                            style={{ minWidth: '800px' }}
                                        />
                                        <label>Versión</label>
                                    </div>

                                </div>}

                        </div>} />

                    <Card
                        titulo={<h5>Enviar a</h5>}
                        contenido={<div className='py-4'>
                            <div className='px-4 d-flex '>
                                <div className='px-4 d-flex'>
                                    <div className="field-radiobutton" onClick={(e) => setEnviarA(2)}>
                                        <RadioButton name="Tipo" value={1} checked={enviarA === 2} />
                                        <label className='mx-2' htmlFor="city4">Personalizado</label>
                                    </div>
                                    <div className="field-radiobutton" onClick={(e) => setEnviarA(1)}>
                                        <RadioButton name="Tipo" value={1} checked={enviarA === 1} />
                                        <label className='mx-2' htmlFor="city4">Rol</label>
                                    </div>
                                    <div className="field-radiobutton" onClick={(e) => setEnviarA(0)}>
                                        <RadioButton name="Tipo" value={0} checked={enviarA === 0} />
                                        <label className='mx-2' htmlFor="city4">Todos</label>
                                    </div>
                                </div>


                            </div>

                            {
                                enviarA === 1 && <div className='px-4 d-flex'>
                                    <div className="p-float-label">
                                        <MultiSelect
                                            value={areaSelected}
                                            options={areas}
                                            onChange={(e) => setAreaSelected(e.value)}
                                            optionLabel="Rol"
                                            // optionValue='IdRol'
                                            display="chip"
                                            style={{ minWidth: '400px', width: '100%' }}
                                            filter
                                            filterBy="Rol"
                                            className={classNames({ 'p-invalid': areaSelected.length === 0 && showErrors })}
                                        />
                                    </div>
                                </div>

                            }

                            {
                                enviarA === 2 && <div className='px-4 d-flex  align-items-center'>
                                    <div className="p-float-label ">
                                        <MultiSelect
                                            value={userSelected}
                                            options={users}
                                            onChange={(e) => setUserSelected(e.value)}
                                            optionLabel="UserName"
                                            // optionValue='idUser'
                                            display="chip"
                                            style={{ minWidth: '400px', maxWidth: 1000 }}
                                            filter
                                            filterBy="UserName"
                                            className={classNames('aa', { 'p-invalid': userSelected.length === 0 && showErrors })}
                                        />
                                    </div>
                                    {userSelected.length > 0 && <p className='ms-3  align-middle' style={{ marginBottom: 0 }}>Seleccionados: {userSelected.length}</p>}
                                </div>
                            }
                            <div className='m-4'>
                                <Button label='Enviar New' onClick={enviarNoticia} />

                            </div>
                        </div>}


                    />

                </div>} />
        </div>
    )
}

export default NewsScreen